import { render, staticRenderFns } from "./JobStats.vue?vue&type=template&id=476224e4&"
import script from "./JobStats.vue?vue&type=script&lang=ts&"
export * from "./JobStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports